    <!-- **********  QUEIXA PRINCIPAL *********** -->
    <mc-appointment-field-detail fieldName="main_complaint" header="Queixa Principal" [appointment]="appointment"></mc-appointment-field-detail>

    <!-- **********  HISTORIA DOENÇA ATUAL *********** -->
    <mc-appointment-field-detail fieldName="current_desease_history" header="História da doença atual" [appointment]="appointment"></mc-appointment-field-detail>

    <!-- **********  EXAME FÍSICO *********** -->
    <mc-appointment-field-detail fieldName="physical_exam" header="Exame físico" [appointment]="appointment"></mc-appointment-field-detail>

    <!-- **********  HISTÓRICO PESSOAL *********** -->
    <mc-appointment-field-detail fieldName="personal_history" header="Histórico pessoal" [appointment]="appointment"></mc-appointment-field-detail>

    <!-- **********  HISTÓRICO FAMILIAR *********** -->
    <mc-appointment-field-detail fieldName="family_history" header="Histórico familiar" [appointment]="appointment"></mc-appointment-field-detail>

    <!-- **********  RESULTADO EXAMES *********** -->
    <mc-appointment-field-detail fieldName="exams_results" header="Resultados de exames" [appointment]="appointment"></mc-appointment-field-detail>

    <!-- **********  CONDUTA *********** -->
    <mc-appointment-field-detail fieldName="conduct" header="Conduta" [appointment]="appointment"></mc-appointment-field-detail>

    <!-- **********  OUTRAS OBSERVAÇÕES *********** -->
    <mc-appointment-field-detail fieldName="other" header="Outras observações" [appointment]="appointment"></mc-appointment-field-detail>


